<template>
  <div class="main-content-container">
    <div class="top-content-container position-relative">
      <b-breadcrumb class="pb-2">
        <b-breadcrumb-item>
          <span
            @click="$router.push({ name: 'Resources' })"
            class="breadcrumb--light font-family-medium text-uppercase"
          >
            Resources
          </span>
        </b-breadcrumb-item>
        <b-breadcrumb-item >
          <span class="breadcrumb--light font-family-medium text-uppercase">
            <span
            @click="$router.push({ name: 'CategoriesList' })"
            class="breadcrumb--light font-family-medium text-uppercase"
          >
            Categories
          </span>
          </span>
        </b-breadcrumb-item>
        <b-breadcrumb-item active>
          <span class="breadcrumb--light font-family-medium text-uppercase">
            {{ isViewMode ? 'View Category' : 'Add Category' }}
          </span>
        </b-breadcrumb-item>
      </b-breadcrumb>
      <div class="d-flex flex-row justify-content-between">
        <h1 class="font-lg font-family-medium primary-dark content-title">
          {{ isViewMode ? 'View Category' : 'Add Category' }}
        </h1>
      </div>
    </div>
    <b-dropdown-divider class="mt-4 mb-4" />
    <b-row>
      <!-- Skeleton loader -->
     
      <!-- End skeleton loader -->
      <b-col cols="12" xl="6">
      <ValidationObserver ref="form">
        <ValidationProvider
          name="categoryName"
          rules="required|maxLengthTitle"
          v-slot="{ errors }"
        >
          <b-form-group
            label="Category name *"
            class="mb-5 mt-5 add-view-category-form-group"
          >
            <b-form-input
              autocomplete="off"
              size="lg"
              type="text"
              :disabled="disableFields"
              class="add-category-name"
              v-model="categoryName"
              placeholder="Add category name"
            ></b-form-input>
            <h6
              v-if="errors[0]"
              data-cy="category-add-error-name"
              class="add-cat-name-err font-sm font-family-regular danger normalize-zIndex"
            >
              {{ errors[0] }}
            </h6>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="categoryDescription"
          rules="required|maxLengthDesc"
          v-slot="{ errors }"
        >
          <b-form-group
            label="Description *"
            class="mb-5 mt-5 add-view-category-form-group"
          >
            <b-textarea
              v-model="categoryDescription"
              rows="10"
              placeholder="Write here"
              no-resize
              class="view-category-desc"
              data-cy="category-add-field-description"
              :disabled="disableFields"
            />
            <h6
              v-if="errors[0]"
              class="add-cat-desc-err font-sm font-family-regular danger normalize-zIndex"
            >
              {{ errors[0] }}
            </h6>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
          name="categoryQuestionnaire"
          v-slot="{ errors }"
        >
          <b-form-group
            label="Questions"
            class="mb-5 mt-5 add-view-category-form-group"
          >
           <quill-editor
              placeholder="Write here"
              rows="10"
              v-model="categoryQuestionnaire"
              no-resize
              class="quill-custom"
              :disabled="disableFields"
              :options="editorOptions"
              :class="{'add-category-desc': true, 'grey-editor': disableFields }"
            ></quill-editor>
            <h6
              v-if="errors[0]"
              class="add-cat-desc-err font-sm font-family-regular danger normalize-zIndex"
            >
              {{ errors[0] }}
            </h6>
          </b-form-group>
        </ValidationProvider>
        <!-- <b-form-group
          class="mb-5 mt-5 add-view-category-form-group"
          label="Checklist"
        >
          <b-input-group @keyup.enter="onChecklistInputEnter">
            <b-form-input
              :disabled="disableFields"
              autocomplete="off"
              class="add-category-check checklist-input"
              size="lg"
              v-model="checklistValue"
              placeholder="Add checklist"
            ></b-form-input>
            <b-input-group-append
              class="position-absolute nav-search-icon-container"
            >
              <img src="@/assets/icons/checklist.svg" alt />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group
          class="mb-5 mt-5 checklist-wrapper"
          v-if="checklist.options.length > 0 && !checklist.toBeDeleted"
        >
          <div class="checklist-container">
            <div
                class="d-flex align-items-center justify-content-between checklist-title-wrapper"
              >
                <b-form-input
                  @keypress.enter="saveChecklistTitle()"
                  type="text"
                  :disabled="disableFields"
                  autofocus
                  v-if="checklist.isEditingTitle"
                  class="checklist-title-input"
                  v-model="newChecklistTitle"
                  placeholder="Add checklist title"
                >
                </b-form-input>
                <h6
                  class="primary--text font-family-medium mb-0 checklist-title"
                  v-else
                  @click="editChecklistTitle()"
                >
                  {{ checklist.title }}
                </h6>
                <b-button
                  class="btn-pill btn-danger px-4 attachment-delete-btn"
                  :disabled="disableFields"
                  :style="{marginLeft: '5px'}"
                  @click="deleteModal.visible = true"
                >
                  Delete
                </b-button>
              </div>
            <Container 
              @drop="onChecklistItemDrop(checklist, $event)" 
              @drag-start="onDragStart"
              @drag-end="onDragEnd"
              non-drag-area-selector=".drag-disabled">
              <Draggable v-for="(option, optionIndex) in checklist.options" :key="optionIndex">
                <div v-if="!option.toBeDeleted" :class="{'drag-disabled': disableFields }"
                  class="d-flex text-align-center checklist-item"
                >
                  <template v-if="!option.isEditing">
                    <b-form-checkbox
                      size="lg"
                      class="checkbox checkbox-title-container"
                      name="check"
                      v-model="option.isChecked"
                    ></b-form-checkbox>
                    <p
                      @click="
                        showChecklistOptionEditBox(optionIndex)
                      "
                      class="primary--text"
                    >
                      {{ option.title }}
                    </p>
                    <div class="close-wrapper">
                      <img
                        class="cursor-pointer remove-option-icon"
                        @click="
                          disableFields
                            ? null
                            : removeChecklistValue(option)
                        "
                        src="@/assets/icons/checklist_close.svg"
                        alt=""
                      />
                    </div>
                  </template>
                  <template v-else>
                    <div class="checklist-option-input-wrapper">
                      <b-form-textarea
                        @keypress.enter="
                          saveChecklistOption(optionIndex)
                        "
                        type="text"
                        autofocus
                        :max-rows="8" :rows="1"
                        size="sm"
                        :style="{ overflowY: 'auto' }"
                        v-if="option.isEditing"
                        v-model="newChecklistOption"
                        class="checklist-option-input"
                        placeholder="Add a checklist option"
                      >
                      </b-form-textarea>
                    </div>
                  </template>
                </div>
              </Draggable>
            </Container>
          </div>
        </b-form-group> -->
          <b-form-group
            label="Checklist"
            class="tasks-form-group"
            v-if="checklists[0] && checklists[0].title"
          >
            <ChecklistComponent
              :checklists="checklists"
              :isFormEnabled="!disableFields"
              :checkboxDisabled="true"
              @saveOption="saveChecklistOption"
              @saveTitle="saveChecklistTitle"
              @editChecklistTitle="editChecklistTitle"
              @deleteChecklist="deleteChecklist"
              @deleteOption="removeOption"
              @editChecklistOption="editChecklistOption"
              @addChecklistOption="addChecklistOption"
              @updateChecklist="updateChecklist"
              class="mb-5"
            />
          </b-form-group>
          <b-form-group
            class="mb-5 mt-5 add-view-category-form-group"
            label="Checklist"
            v-else
          >
            <b-input-group @keyup.enter="onChecklistInputEnter">
              <b-form-input
                :disabled="disableFields"
                autocomplete="off"
                class="add-category-check checklist-input"
                size="lg"
                v-model="checklistTitle"
                placeholder="Add checklist"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        <b-form-group
          class="mb-2 mt-5 add-view-category-form-group"
          label="Attachment"
        >
          <b-input-group class="d-flex flex-column">
            <label class="file-select">
              <div
                :class="[
                  !disableFields ? 'cursor-pointer' : 'disabled-form'
                ]"
                class="d-flex flex-row justify-content-between w-100 px-3 py-2 border-radius-sm border-primary-lighter"
              >
                <h6 class="font-family-regular mb-0">
                  Add attachment
                </h6>
                <img src="@/assets/icons/attachments.svg" alt />
              </div>
              <input
                type="file"
                :accept="ACCEPTED_FILE_TYPES"
                hidden
                ref="fileInput2"
                :disabled="disableFields"
                @change="fileChange"
                multiple
                data-cy="category-add-field-attachment"
                class="d-none add-category-attach"
              />
            </label>
          </b-input-group>
          <h6 class="danger" v-if="sizeExceed">
            Size cannot be greater than 500MB
          </h6>
        </b-form-group>
        <b-row
          v-for="(attachment, index) in attachments.filter(attachment => !attachment.toBeDeleted)"
          :key="index"
          align-v="center"
          align-h="center"
          class="mt-4 mb-3 add-attachments-list attachments-row"
        >
          <div
          v-if="!isImage(attachment)"
          class="box-container bg--primary-light d-flex align-items-center justify-content-center">
            <template v-if="!isFile(attachment)">
              <a :href="attachment.attachment.attachmentFile" target="_blank"
                  v-if="attachment.attachment.filetype === 'pdf'"
              >
                <h1 class="primary--text font-family-medium">
                  {{ attachment.attachment.filetype.toUpperCase() }}
                </h1>
              </a>
              <a :download="attachment.attachment.name" :title="attachment.attachment.name"
                :href="attachment.attachment.attachmentFile" v-else
              >
                <h1 class="primary--text font-family-medium">
                  {{ attachment.attachment.filetype.toUpperCase() }}
                </h1>
              </a>
            </template>
            <h1 v-else>
              <a :href="URL.createObjectURL(attachment)" target="_blank" class="primary--text font-family-medium" 
                  v-if="getFileExtension(attachment) === 'PDF'"
              > {{ getFileExtension(attachment) }}</a>
              <a :title="attachment.name" class="primary--text font-family-medium" 
              :href="URL.createObjectURL(attachment)" :download="attachment.name" v-else
              >
                {{ getFileExtension(attachment) }}
              </a>
            </h1>
          </div>
          <div
            v-else
            @click="onThumbnailClick(attachment, index)"
            class="box-container bg--primary-light d-flex align-items-center justify-content-center thumbnail-wrapper"
          >
            <img
              :src="attachment.attachment.thumbnail"
              v-if="attachment.attachment"
            />
            <img :src="URL.createObjectURL(attachment)" v-else />
          </div>
          <b-col class="ml-4">
            <b-row>
              <p v-if="attachment.attachment">
                {{ attachment.attachment.filename }}
              </p>
              <p v-if="attachment.name">
                  {{ attachment.name }}
              </p>
            </b-row>
            <b-row>
              <b-button
                :disabled="disableFields"
                data-cy="attachment-delete-btn"
                class="btn-danger px-4 btn-pill attach-delete"
                @click="deleteAttachment(attachment)"
              >
                Delete
              </b-button>
            </b-row>
          </b-col>
        </b-row>
        <b-row
          v-if="showValidity && !showError"
          class="mx-0 mb-2"
          align-v="center"
        >
          <b-alert
            :show="showValidity"
            class="add-cat-success alert-btn-top w-100 custom-alert add-category-alert mb-2 mt-1"
          >
            {{ message }}
          </b-alert>
        </b-row>
        <b-row v-if="showError" class="mx-0 mb-2" align-v="center">
          <b-alert
            :show="showError"
            class="alert-btn-top w-100 custom-alert add-category-alert mb-2 mt-1"
          >
            {{ error }}
          </b-alert>
        </b-row>
        <b-row class='save-button-row' v-if="isAdmin()">
          <b-col cols="12">
            <div>
              <b-button
                class="add-category-save save-button px-5 py-3 btn-pill"
                @click="onSaveClick"
                :disabled="disableFields"
              >
                <b-spinner
                  v-if="saveLoader"
                  style="width: 14px; height: 14px"
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <template v-else>Save</template>
              </b-button>
            </div>
            <div v-if="isViewMode">
              <b-button
                data-cy="category-delete-button"
                class="add-category-save px-5 py-3 btn-pill btn-danger"
                @click="deleteCategoryModal.visible = true"
                :disabled="disableFields"
              >
                <b-spinner
                  v-if="isDeleting"
                  style="width: 14px; height: 14px"
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                <template v-else>Delete</template>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
      </b-col>
    </b-row>
    <b-modal size="lg" centered v-model="previewModal.visible" content-class="preview-modal"
    :hide-header="true" :hide-footer="true">
    <div class="preview-modal-header">
      <div class="header-text">{{ previewModalData.title }}</div>
      <b-button id="delete-button"  @click="onDeleteImage" v-if="isAdmin()">Delete</b-button>
      <b-button id="download-button" @click="onPreviewModalDownload">Download</b-button>
      <b-button id="close-button" @click="previewModal.visible = false">
        <img src="@/assets/icons/close_sidebar.svg"/>
      </b-button>
      <a :href="previewModalData.src" :title="previewModalData.title" :download="previewModalData.title"
      :style="{display: 'none'}" ref="downloadAnchor"></a>
    </div>
    <div class="preview-modal-image-wrapper">
      <img :src="previewModalData.src"/>
    </div>
    </b-modal>
    <b-modal
        centered
        class="modal-padding"
        hide-footer
        v-model="errorModal.visible"
        hide-header
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-container fluid>
          <b-button
            @click="errorModal.visible = false"
            class="d-flex position-absolute error-modal-close-btn"
          >
            <img
              class="close-icon"
              src="@/assets/icons/close_sidebar.svg"
              alt
            />
          </b-button>
          <b-row align-v="center" class="px-2 py-2">
            <b-col md="9" class="d-flex mb-2">
              <h4 class="font-family-medium mt-2">
                {{ errorModal.message }}
              </h4>
            </b-col>
          </b-row>
        </b-container>
    </b-modal>
    <b-modal
      id="delete-checklist-modal"
      v-model="deleteModal.visible"
      body-class="delete-checklist-modal-body"
      hide-header
      hide-footer
      centered
    >
      <h1>Are you sure?</h1>
      <h3>Do you want to delete the checklist?</h3>
      <div class="buttons-row">
        <div class="buttons-wrapper">
          <div class="button-wrapper">
            <b-button class="cancel-button" @click="deleteModal.visible = false"
              >Cancel</b-button
            >
          </div>
          <div class="button-wrapper">
            <b-button
              class="delete-button"
              @click="deleteChecklist"
              :disabled="isLoading"
              >Confirm Delete</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="delete-category-modal"
      v-model="deleteCategoryModal.visible"
      body-class="delete-category-modal-body"
      hide-header
      hide-footer
      centered
    >
      <h1>Are you sure?</h1>
      <h3>Do you want to delete the category?</h3>
      <div class="buttons-row">
        <div class="buttons-wrapper">
          <div class="button-wrapper">
            <b-button 
            class="cancel-button" 
            @click="deleteCategoryModal.visible = false"
            >
              Cancel
            </b-button>
          </div>
          <div class="button-wrapper">
            <b-button
              class="delete-button"
              data-cy="category-delete-button-confirm"
              @click="deleteCategory"
              :disabled="isDeleting"
              >Confirm Delete</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor"
import { updateChecklistItemPositions, onChecklistItemDrop, onDragStart, onDragEnd } from '@/utils/checklistDndUtils'
import {
  getCategories,
  getCategory,
  patchCategory,
  patchCheckList,
  postCategory,
  deleteCheckList,
  postCategoryAttachment,
  postCheckList,
  deleteCategoryAttachment,
  deleteChecklistOption,
  deleteCategory
} from "@/apis/common/index";
import { isFile, getFileExtension, isImage, isAdmin, uploadFile } from '@/utils/utils'
import { editorOptions, ACCEPTED_FILE_TYPES } from '@/utils/constants'
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import ChecklistComponent from "@/components/checklists/ChecklistComponent";
extend("required", {
  message: () => "This is a required field"
});
let maxLengthTitleMsg = "";
extend("maxLengthTitle", {
  message: () => `${maxLengthTitleMsg}`,
  validate: value => {
    if (value.length <= 200) {
      return true;
    } else {
      maxLengthTitleMsg = "Title can contain only 200 characters";
      return false;
    }
  }
});
let maxLengthDescMsg = "";
extend("maxLengthDesc", {
  message: () => `${maxLengthDescMsg}`,
  validate: value => {
    if (value.length < 250) {
      return true;
    } else {
      maxLengthDescMsg = "Description can contain only 250 characters";
      return false;
    }
  }
});
export default {
  name: "AddViewCategory",
  components: {
    ValidationObserver,
    ValidationProvider,
    quillEditor,
    ChecklistComponent
  },
  data() {
    return {
      ACCEPTED_FILE_TYPES,
      errorModal: {
        visible: false,
        message: 'File is empty. Cannot upload'
      },
      deleteModal: {
        visible: false
      },
      deleteCategoryModal: {
        visible: false
      },
      isDeleting: false,
      URL: window.URL,
      previewModal: {
        visible: false,
        src: "",
        attachment: null
      },
      editorOptions,
      message: "",
      sizeExceed: false,
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      attachments: [],
      checklistTitle: null,
      checklists: [],
      checklistValue: "",
      categoryName: "",
      categoryDescription: "",
      categoryQuestionnaire: "",
      fileURL: [],
      showValidity: false,
      showError: false,
      categories: [],
      attachmentIds: [],
      patchORpost: false,
      checklistId: "",
      totalApiCalls: [],
      error: "Some error occured",
      passedApiCalls: [],
      saveLoader: false,
      attachmentDeleteLoader: false,
      deleteCheckListLoader: false,
      isLoading: true,
      isLoadingCategories: true,
      optionsToBeDeleted: [],
      checklistToBeDeleted: null,
      categoryAlreadyExists: false
    };
  },
  mounted() {
    this.fetchCategoryList();
    if (this.isViewMode) {
      this.fetchCategoryData().then(() => this.isLoading = false)
    } else {
      this.isLoading = false
    }
  },
  computed: {
    isViewMode() {
      return this.$route.meta.isViewMode
    },
    disableFields() {
      return this.isLoading || !isAdmin() || this.isDeleting
    },
    categoryId() {
      return this.$route.params.id
    },
    previewModalData() {
      let { previewModal } = this;
      if (!previewModal.attachment) {
        return {
          src: "",
          title: "",
          thumbnail: ""
        };
      }
      if (previewModal.attachment instanceof File) {
        let blobUrl = window.URL.createObjectURL(previewModal.attachment);
        return {
          src: blobUrl,
          title: previewModal.attachment.name,
          thumbnail: blobUrl
        };
      }
      return {
        src: previewModal.attachment.attachment.attachmentFile,
        title: previewModal.attachment.attachment.filename,
        thumbnail: previewModal.attachment.attachment.thumbnail
      };
    },
    ...mapState("authModule", ["role", "profileUserId"]),
  },
  methods: {
    isFile, 
    isAdmin,
    getFileExtension,
    isImage,
    forceRender(checklistDeleteModal) {
      // to rerender the component as somehow state change is not able force to rerender
      checklistDeleteModal.visible = true;
      checklistDeleteModal.visible = false;
    },
    saveChecklistTitle(index, newChecklistTitle, checklistDeleteModal) {
      let checklist = this.checklists[index];
      if (newChecklistTitle.length > 0) {
        checklist.title = newChecklistTitle;
      }
      this.forceRender(checklistDeleteModal);
    },
    editChecklistTitle(checklistDeleteModal) {
      this.forceRender(checklistDeleteModal);
    },
    fetchCategoryList() {
      getCategories()
        .then(res => {
          this.categories = [...res.data.results];
        })
        .catch(err => {
          console.log(err);
          this.isLoadingCategories = false;
        })
        .finally(() => {
          this.isLoadingCategories = false;
        });
    },
    async fetchCategoryData() {
      this.isLoading = true
      this.showValidity = false;
      this.showError = false;
      try {
        let res = await getCategory(this.categoryId)
        this.categoryName = res.data.title;
        this.categoryDescription = res.data.description;
        this.categoryQuestionnaire = res.data.inlineQuestionnaire
        if (res.data.checklists.length > 0) {
          let checklist = res.data.checklists[0]
          checklist.options.sort((option1, option2) => option1.position - option2.position)

          // set this property here so we don't have to use $set later
          checklist.toBeDeleted = false
          // checklist.isEditingTitle = false
          checklist.options.forEach(option => {
            option.isChecked = false
            option.toBeDeleted = false
          })
          this.checklists[0] = checklist;
        }
        this.attachments = res.data.attachments.map(attachment => {
          return {
            ...attachment,
            toBeDeleted: false,
            loader: false
          }
        })
      } catch(e) {
        console.log(e.response);
      } finally {
        this.isLoading = false;
      }
    },
    fileChange(event) {
      const extensions = this.ACCEPTED_FILE_TYPES
        .split(",")
        .filter(item => item[0] === '.');

      this.sizeExceed = false;
      let sizing = true;
      for (let i = 0; i < event.target.files.length; i++) {
        if (event.target.files[i].size / 1024 / 1024 > 500) {
          sizing = false;
          break;
        }
      }
      // empty file validation
      for (let file of event.target.files) {
        const fileExtension = `.${file.name.split(".").reverse()[0]}`
        const isRestrictedFileType = !extensions.includes(fileExtension)
        if (isRestrictedFileType) {
          this.errorModal.message = `${file.name} file format is not supported, please contact admin for more details.`;
          this.errorModal.visible = true;
          this.$refs.fileInput2.value = "";
          return;
        }

        if (file.size === 0) {
          this.errorModal.message = `${file.name} is empty. Cannot upload.`
          this.errorModal.visible = true
          let { fileInput2 } = this.$refs
          // the if checks are necessary because if refs won't exist until 
          // a sidebar is opened (mounted onto the DOM)
          if (fileInput2) {
            this.$refs.fileInput2.value = ''
          }
          return
        }
      }
      if (sizing) {
        for (let i = 0; i < event.target.files.length; i++) {
          this.attachments.push(event.target.files[i]);
          this.attachments[i].loader = false;
        }
      } else {
        this.sizeExceed = true;
      }
      let { fileInput2 } = this.$refs
      // the if checks are necessary because if refs won't exist until 
      // a sidebar is opened (mounted onto the DOM)
      if (fileInput2) {
        this.$refs.fileInput2.value = ''
      }
    },
    async addCategory() {
      this.showError = false;
      this.showValidity = false;
      this.saveLoader = true;
      const valid = await this.$refs.form.validate();
      if (!valid) {
        this.showValidity = true;
        this.message = "There are invalid form fields";
        this.saveLoader = false;
        return
      }
      const payload = {
        title: this.categoryName,
        description: this.categoryDescription,
        inlineQuestionnaire: this.categoryQuestionnaire
      };
      this.isLoading = true
      let categoryId
      try {
        // create the category
        let res = await postCategory(payload)
        if(res.status==200){
          this.categoryAlreadyExists=true
        }
        // save the newly created id into a local variable
        categoryId = res.data.id

        // saving the checklist if any
        let checklistOptions = this.checklists[0]?.options?.map(option => ({
          title: option.title
        }))
        if (checklistOptions?.length > 0) {
          try {
            await postCheckList(categoryId, {
              title: this.checklists[0].title,
              options: checklistOptions
            })
          } catch(e) {
            console.log(e)
          }
        }

        // saving the attachments
        try {
          await Promise.all(this.attachments.map(async (attachment) => {
            try {
              let response = await uploadFile(attachment)
              await postCategoryAttachment(categoryId, {
                category: categoryId,
                attachment: response.data.id
              })
            } catch(e) {
              console.log(e)
            }
          }))
          this.$router.push({
            name: 'CategoriesList',
            params: {categoryExists:
               this.categoryAlreadyExists}
          })
        } catch(e) {
          this.error = "some error occured";
        }
      } catch(e) {
        console.log(e)
        this.saveLoader = false;
        this.showError = true;
        if (e.response.status === 401) {
          this.error = "User token expired. Please logout and login again."
        } else if (e.response.data.title.length > 0) {
          this.error = "Category name already exists";
        } else {
          this.error = "Some error occured";
        }
        console.log(e)
      } finally {
        this.saveLoader = false
        this.isLoading = false
      }
    },
    async saveChecklist() {
      let checklist = this.checklists[0];
      if (this.checklistToBeDeleted) {
        try {
          await deleteCheckList(this.categoryId, this.checklistToBeDeleted);
        } catch(e) {
          console.log(e);
        }
      }
      if (checklist.toBeDeleted || (checklist.options.length === 0 && checklist.id)) {
        return deleteCheckList(this.categoryId, checklist.id)
      }
      if (!checklist.toBeDeleted && checklist.options.length === 0 ) {
        return true
      }
      let options = checklist.options.filter(option => !option.toBeDeleted)
      options.forEach((option, index) => {
        option.position = index + 1
      })

      if (checklist.id) {
        try {
          await deleteChecklistOption(
            this.categoryId,
            checklist.id, // using the bulk delete API
            this.optionsToBeDeleted
          )
          this.optionsToBeDeleted.length = 0;
        } catch(e) {
          console.log(e)
        }
        const payload = {
          title: checklist.title,
          category: this.categoryId,
          options
        }
        return patchCheckList(this.categoryId, checklist.id, payload)
      } else {
        const payload = {
          title: checklist.title,
          options
        }
        return postCheckList(this.categoryId, payload)
      }
    },
    async patchData() {
      this.showValidity = false;
      this.showError = false;
      const valid = await this.$refs.form.validate();
      // validation
      if (!valid) {
        this.showValidity = true
        this.message = "There are invalid form fields";
        return
      }
      
      this.saveLoader = true;
      const data = {
        title: this.categoryName,
        description: this.categoryDescription,
        inlineQuestionnaire: this.categoryQuestionnaire
      };
      this.isLoading = true

      try {
        await patchCategory(this.categoryId, data)
        let attachmentsToBeDeleted = this.attachments.filter(attachment => attachment.toBeDeleted)
        let attachmentsToBeUploaded = this.attachments.filter(attachment => attachment instanceof File)

        try {
          await Promise.all(attachmentsToBeDeleted.map(attachment => {
            return deleteCategoryAttachment(this.categoryId, attachment.id)
          }))
          await Promise.all(attachmentsToBeUploaded.map(async (attachment) => {
            let res = await uploadFile(attachment)
            return postCategoryAttachment(this.categoryId, {
              category: this.categoryId,
              attachment: res.data.id
            })        
          }))
        } catch(e) {
          console.log(e)
        }
        // saving the checklist
        try {
          await this.saveChecklist()
        } catch(e) {
          console.log(e)
        }
        this.saveLoader = false;
        this.showValidity = true;
        this.message = "Details saved successfully";
        this.$router.go(-1)
      } catch(err) {
        console.log(err)
        this.showError = true;
        if (err.response.status === 401) {
          this.error = 'User token expired. Please logout and login again.'
        } else if (err.response.data.title.length > 0) {
          this.error = "Category name already exists";
        } else {
          this.error = "Some error occured";
        }
      } finally {
        this.saveLoader = false;
        this.isLoading = false
      }
    },
    resetForm() {
      this.showValidity = false;
      this.checklistValue = "";
      this.categoryName = "";
      this.categoryDescription = "";
      this.checklist = [];
      this.attachments = [];
      this.showError = false;
      this.sizeExceed=false
    },
    deleteAttachment(attachment) {
      if (this.isViewMode && attachment.id) {
        attachment.toBeDeleted = true
      } else {
        this.attachments = this.attachments.filter(_attachment => attachment !== _attachment)
      }
    },
    onChecklistInputEnter() {
      if (this.checklistTitle !== "") {
        if (!this.checklists.length) {
          this.checklists.push({
            options: [],
            toBeDeleted: false,
            title: ""
          });
        }
        this.checklists[0].title = this.checklistTitle;
      }
    },
    addChecklistOption(checklistDeleteModal) {
      this.forceRender(checklistDeleteModal);
    },
    updateChecklist(checklist, checklistDeleteModal) {
      this.forceRender(checklistDeleteModal);
    },
    editChecklistOption(checklistDeleteModal) {
      this.forceRender(checklistDeleteModal);
    },
    saveChecklistOption(option, checklistIndex, optionIndex, isNewOption, checklistDeleteModal) {
      if (!option.length > 0) {
        return;
      }
      if (isNewOption) {
        this.checklists[checklistIndex].options.push({
          title: option
        });
      } else {
        this.$set(
          this.checklists[checklistIndex].options[optionIndex],
          "isEditing",
          false
        );
      }
      this.forceRender(checklistDeleteModal);
    },
    deleteChecklist() {
      if (this.isViewMode && this.checklists[0].id) {
        this.checklists[0].options.forEach(option => {
          this.optionsToBeDeleted.push(option.id);
        });
      }
      this.checklistToBeDeleted = this.checklists[0].id;
      this.checklists = [];
      // this.checklists[0].title = "";
      this.deleteModal.visible = false;
      // this.forceRender(checklistDeleteModal);
    },
    removeOption(checklistIndex, optionIndex, checklistDeleteModal) {
      // to store ids of options to be removed on Save.
      this.optionsToBeDeleted.push({
        id: this.checklists[checklistIndex].options[optionIndex].id
      });
      this.checklists[checklistIndex].options.splice(optionIndex, 1);
      this.forceRender(checklistDeleteModal);
    },
    onSaveClick() {
      if (this.isViewMode) {
        this.patchData()
      } else {
        this.addCategory()
      }
    },
    async deleteCategory() {
      this.isDeleting = true
      try {
        await deleteCategory(this.categoryId)
        this.$router.push({
          name: 'CategoriesList'
        })
      } catch(e) {
        console.log(e)
        this.error = "Some error occured. Failed to delete";
      } finally {
        this.isDeleting = false
      }
    },
    onPreviewModalDownload() {
      // forcibly download the file
      this.$refs.downloadAnchor.click()
    },
    onThumbnailClick(attachment, attachmentIndex) {
      this.previewModal.attachment = attachment;
      this.previewModal.attachmentIndex = attachmentIndex;
      this.previewModal.visible = true;
    },
    onDeleteImage() {
      let { attachment } = this.previewModal
      this.deleteAttachment(attachment)
      this.previewModal.visible = false
    },
    onChecklistItemDrop,
    updateChecklistItemPositions,
    onDragStart,
    onDragEnd
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
@import "~@/scss/variables/helpers.scss";
.sidebar-title {
  margin-top: 2rem;
}
.checklist-title {
  bottom: 0.7rem;
  font-size: 1.4rem;
}
.add-category-alert {
  max-width: 100%;
}
.close-btn {
  left: -5.5%;
  top: 3rem;
  background: none !important;
}
.delete-btn {
  margin-right: 3rem;
  margin-top: 2.5rem;
  height: 3rem;
  width: 3rem;
  background: $danger 0% 0% no-repeat padding-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    flex: 1;  
  }
}
.close-icon {
  width: 3rem;
  height: 3rem;
}
.delete-icon {
  width: 1.5rem;
  height: 1.5rem;
  background: transparent;
}
.nav-search-input1 {
  width: 28rem !important;
  border-radius: 21px !important;
  padding-top: 1.55rem !important;
  padding-bottom: 1.55rem !important;
  padding-left: 1.5rem !important;
}
.nav-search-icon-container {
  right: 1rem;
  top: 1.2rem;
}
.nav-search-icon-container1 {
  right: 1rem;
  top: 1rem;
}
// .nav-search-icon-container img {
//   width: 1.2rem;
//   height: 1.2rem;
// }
// .nav-search-icon-container1 img {
//   width: 1.5rem;
//   height: 1.5rem;
// }
.checklist-container {
  border: 1px solid #dcebf4;
  border-radius: 4px;
  background-color: white;
  box-sizing: border-box;
  padding: 14px 18px 18px 18px;
  p {
    margin: 0;
  }
}
.b-sidebar-backdrop {
  width: 100% !important;
  height: 100% !important;
}
.main-content-container {
  // giving the container a fixed height and making it scrollable to facilitate
  // scrolling while dragging a checklist item, since body does not scroll
  // https://github.com/kutlugsahin/vue-smooth-dnd/issues/18
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - #{$navbar-height});
}
.card-icon-container {
  right: 1rem;
  top: 1rem;
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.error-modal-close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none !important;
}
.attachments-row {
  padding: 0 0rem 0 2rem;
  .box-container {
    height: 10rem;
    width: 15rem;
    border-radius: 6px;
  }
}
.save-button-row {
  padding-top: 15px;
  padding-bottom: 15px;
  button.save-button {
    background: $button-secondary;
  }
  >div {
    display: flex;
    >div {
      padding-right: 10px;
    }
  }
}
label.file-select {
  >div {
    background-color: white;
  }
}
.checklist-item {
  display: flex;
  padding: 9px 0px 2px 9px;
  .checkbox {
    top: 0.2rem;
  }
  p {
    cursor: pointer;
    word-break: break-word;
  }
  .close-wrapper {
    padding-left: 10px;
    margin-left: auto;
  }
}
.checklist-option-input-wrapper {
  flex: 1;
}
.file-select {
  h6 {
    font-size: 1.4rem;
    line-height: 3rem;
  }
}
</style>
<style lang="scss">
.checklist-title-input {
  width: 80%;
  z-index: 5;
}
</style>
